/** @jsxImportSource @emotion/react */
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { INode, INodeTypes } from "../../../../types/CampaignTypes";
import IconBerserkerMail from "../../../Icon";
import StyledInput from "../../../StyledInput";
import StyledTextArea from "../../../StyledTextArea";
import Form, { DefaultFormProps, FormInstance } from "./Form";
import { Container, Label, Row, Title } from "./PushNotification";

const SmsNotification = ({
  action,
  nodeIndex,
}: DefaultFormProps): JSX.Element => (
  <Form {...{ action, nodeIndex }}>
    {({
      updateCampaign,
      tempCampaign,
      updateNodeDescription,
    }: FormInstance) => {
      const [name, setName] = useState<string>("");
      const [message, setMessage] = useState<string>("");
      const [title, setTitle] = useState<string>("");
      const [editing, setEditing] = useState<boolean>(true);

      const currentNode = tempCampaign?.nodes[nodeIndex];

      useEffect(() => {
        if (currentNode) {
          setName(currentNode.name || "");
          setMessage(currentNode.sms?.message || "");
          // setMessage(currentNode.sms?.title);
          setEditing(action === "edit");
        }
      }, [action, nodeIndex]);

      useEffect(() => {
        updateNodeDescription(name);
      }, [name]);

      const saveForm = () => {
        if (message && name) {
          const newAction: INode = {
            _id: currentNode?._id,
            name: name as string,
            type: INodeTypes.Sms,
            sms: {
              message,
            },
          };

          updateCampaign(
            newAction,
            action === "create" ? "Email created" : "Email updated"
          );
        } else {
          toast("All fields are required", { type: "info" });
        }
      };

      const Component = (
        <Container>
          <Title>
            <IconBerserkerMail name="sms" />
            &nbsp;SMS NOTIFICATION
          </Title>

          <Row>
            <Label>SMS Notification Name</Label>
            <StyledInput
              disabled={!editing}
              placeholder="Enter SMS notification name"
              value={name}
              onChange={(evt) => setName(evt.target.value)}
            />
          </Row>

          <Row>
            <Label>Title</Label>
            <StyledInput
              disabled={!editing}
              placeholder="Enter SMS notification title"
              value={title}
              onChange={(evt) => setTitle(evt.target.value)}
            />
          </Row>

          <Row>
            <Label>Message</Label>
            <StyledTextArea
              disabled={!editing}
              placeholder="Enter SMS notification message"
              value={message}
              onChange={(evt) => setMessage(evt.target.value)}
            />
          </Row>
        </Container>
      );

      return {
        Component,
        saveForm,
      };
    }}
  </Form>
);

export default SmsNotification;
